import React from "react";
import Card from "../UI/Card";
import classes from "./IconWithValue.module.css";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Tooltip from "@mui/material/Tooltip";

interface IconWithValueProps {
  title: string; // Título como "TEMPERATURA ACTUAL"
  value: number | null | undefined; // Valor dinámico; null/undefined para "sin datos"
  unit: string; // Unidad como "°C"
  icon: React.ReactNode; // Ícono pasado como un componente
  headerColor?: string;
  textColor?: string;
  recvTime?: string; // recvTime de la muestra para tooltip
}

const IconWithValue: React.FC<IconWithValueProps> = ({ title, value, unit, icon, headerColor, textColor, recvTime }) => {
  const tooltipText = (() => {
    if (value === null || value === undefined) return "Sin datos";
    if (!recvTime) return "Sin hora";
    const d = new Date(recvTime);
    if (isNaN(d.getTime())) return String(recvTime);
    return d.toLocaleString();
  })();
  return (
    <Card title={title} headerColor={headerColor} textColor={textColor}>
      <div className={classes.container}>
        <div className={classes.icon}>{icon}</div>
        <Tooltip title={tooltipText} placement="top" arrow>
          <div className={classes.value}>
            {value === null || value === undefined ? (
              <WarningAmberIcon color="warning" fontSize="large" titleAccess="Sin datos" />
            ) : (
              <>
                {value} <span className={classes.unit}>{unit}</span>
              </>
            )}
          </div>
        </Tooltip>
      </div>
    </Card>
  );
};

export default IconWithValue;
